import { gate } from 'hub-http/gates';
import { createSelector } from 'reselect';
export const getUserIdFromAuth = state => state.auth.user.user_id;
export const getFirstNameFromAuth = state => state.auth.user.first_name;
export const getLastNameFromAuth = state => state.auth.user.last_name;
export const getPortalIdFromAuth = state => state.auth.portal.portal_id;
export const getScopesFromAuth = state => state.auth.user.scopes;
export const getGatesFromAuth = state => state.auth.gates;
export const getEmailFromAuth = state => state.auth.user.email;
export const getActingUserIdFromAuth = state => state.auth.user.acting_user_id;
export const getHasRemoveFromAccountScope = createSelector([getScopesFromAuth], scopes => scopes.includes('self-remove-user'));
export const isApplicationHubless = state => !getPortalIdFromAuth(state);
export const getPasskeysIsUngated = createSelector([isApplicationHubless, getGatesFromAuth], (isHubless, gates) => isHubless ? gates.includes('Login:PasskeyLogin') : gates.includes(gate('Login:PasskeyLogin')));
export const getIsUserImpersonated = createSelector([getActingUserIdFromAuth], actingUserId => !!actingUserId);